import './NoAccessPage.css';

import noAccessLogo from './../../image/logo.svg';
import noAccessImage from './../../image/image-2.png';

const NoAccessPage = () => {
    const handleCloseClick = () => {
        if (window.Telegram && window.Telegram.WebApp) {
            window.Telegram.WebApp.close();
        }
    };

    return (
        <div className='noaccess__wrapper'>
            <div className='noaccess__logo'>
                <img src={noAccessLogo} alt='Logo' />
            </div>

            <div className='noaccess__image'>
                <h3 className='noaccess__title'>
                    Возвращайтесь, как подрастёте...
                </h3>
                <img src={noAccessImage} />
            </div>

            <div className='noaccess__btn_items'>
                <button className='noaccess__btn' onClick={handleCloseClick}>
                    Закрыть
                </button>
            </div>
        </div>
    );
};

export default NoAccessPage;
